// ===========================================================================
// DEBUG PANEL: never shown unless the page is loaded with ?glassDebug.
// Floating slider panel to tune the liquid-glass instances live; prints the
// values so you can copy them into the data-lg-* attributes.
// It reads the instances off window.app.liquidGlass, so no production code
// references it.
// ===========================================================================

import {LIQUID_GLASS_DEFAULTS} from "./LiquidGlass";

// Tuning params: [option key, min, max, step].
const DEBUG_PARAMS = [
  ["depth", 0, 40, 1],
  ["strength", 0, 300, 5],
  ["chromaticAberration", 0, 20, 1],
  ["blur", 0, 20, 0.5],
];

function buildPanel(instances) {
  const current = {...LIQUID_GLASS_DEFAULTS, ...instances[0].options};

  const panel = document.createElement("div");
  panel.style.cssText =
    "position:fixed;top:12px;right:12px;z-index:99999;background:rgba(0,0,0,.8);" +
    "color:#fff;font:12px/1.4 monospace;padding:12px 14px;border-radius:8px;" +
    "width:240px;backdrop-filter:none;pointer-events:auto;user-select:none";
  panel.innerHTML = `<div style="font-weight:bold;margin-bottom:8px">Liquid glass</div>`;

  const readout = document.createElement("pre");
  readout.style.cssText = "margin:8px 0 0;white-space:pre-wrap;color:#9fe";
  const printReadout = () => {
    readout.textContent =
      `data-lg-depth="${current.depth}"\n` +
      `data-lg-strength="${current.strength}"\n` +
      `data-lg-chromatic="${current.chromaticAberration}"\n` +
      `data-lg-blur="${current.blur}"`;
  };

  for (const [key, min, max, step] of DEBUG_PARAMS) {
    const row = document.createElement("label");
    row.style.cssText = "display:flex;align-items:center;gap:8px;margin:6px 0";
    const name = document.createElement("span");
    name.style.cssText = "flex:0 0 96px";
    name.textContent = key === "chromaticAberration" ? "aberration" : key;
    const slider = document.createElement("input");
    slider.type = "range";
    slider.min = min;
    slider.max = max;
    slider.step = step;
    slider.value = current[key];
    slider.style.flex = "1";
    const val = document.createElement("span");
    val.style.cssText = "flex:0 0 32px;text-align:right";
    val.textContent = current[key];
    slider.addEventListener("input", () => {
      const v = parseFloat(slider.value);
      current[key] = v;
      val.textContent = v;
      instances.forEach((g) => g.set({[key]: v}));
      printReadout();
    });
    row.append(name, slider, val);
    panel.appendChild(row);
  }

  printReadout();
  panel.appendChild(readout);
  document.body.appendChild(panel);
}

function init() {
  if (!new URLSearchParams(window.location.search).has("glassDebug")) return;
  const tryAttach = () => {
    const instances = window.app && window.app.liquidGlass;
    if (!instances || !instances.length) return setTimeout(tryAttach, 200);
    buildPanel(instances);
  };
  tryAttach();
}

init();
